window.checkToggle = function(e,data) {
    var json = JSON.parse($(data).html());
    var value = $(e).val();
    if(json && json[value] != undefined) {
        $.each(json[value],function(key,val) {
            $(key).val(val);
        });
    }
}
